import { Typography } from '@mui/material'
import { isFuture, isPast, parseISO } from 'date-fns'
import application from '~/config/application'

const startDate = application.stage !== 'production' ? parseISO('2024-10-01T00:00:00.000Z') : parseISO('2024-10-09T00:00:00.000Z')
const endDate = parseISO('2024-11-04T23:59:59.999Z')

export const RecyclingWeek24Header: React.FC = () => {
  if (isPast(endDate) || isFuture(startDate)) return null

  return <>
    <Typography>
      From 9th October 2024 until 5th November 2024, you can receive an additional 175 Advantage Card points when you recycle two of these items: lipstick, hand cream, body lotion, travel mini, refill pouch and dental products in a single deposit and spend £10 or more in-store*
    </Typography>
    <Typography>
      To take full advantage of the scheme please remember to scan both points vouchers after your Advantage Card at the point of sale. You can swipe to navigate between the vouchers.
    </Typography>
    <Typography>
      * Voucher valid for 3 days from day it is issued and must be redeemed in a participating store no later than 7th November 2024, please see below for full terms and conditions. Latest redemption is 7th November 2024.
    </Typography>
  </>
}
